import React from 'react';
import PropTypes from 'prop-types';
import classes from './Legal.module.css';

const Legal = (props) => {
    if (!props.show) {
        return null;
    }

    return (
        <div className={classes.LegalContainer}>
            {/* Backdrop */}
            <div 
                className={classes.LegalBackdrop}
                onClick={props.onClick}
            />
            {/* Modal Card */}
            <div className={classes.LegalCard}>
                <div className={classes.LegalCardBody}>
                    <div className={classes.LegalContents}>
                        {props.children}
                    </div>
                </div>
            </div>
        </div>
    );
}

Legal.propTypes = {
    show: PropTypes.bool.isRequired,
    onClick: PropTypes.func.isRequired,
    children: PropTypes.node.isRequired
};

export default Legal;